module.exports = __webpack_public_path__ + "img/swe.dbea8e19.png";